export function getTitle(metadata, content) {
  return content.title ? content.title : metadata.title ? metadata.title : metadata.ogtitle ? metadata.ogtitle : ''
}

export function getOGTitle(metadata, content) {
  return metadata.ogtitle ? metadata.ogtitle : metadata.title ? metadata.title : content.title ? content.title : ''
}
export function getOGDescription_long(metadata, content) {
  //Do not validate complete text first because this is required, the description is used as fallback
  return content.tx_headless_news_text
    ? content.tx_headless_news_text
    : content.tx_headless_news_teaser
      ? content.tx_headless_news_teaser
      : metadata.ogdescription
        ? metadata.ogdescription
        : ''
}
export function getOGDescription_short(metadata, content) {
  //Do not validate complete text first because this is required, the description is used as fallback
  return content.tx_headless_news_teaser ? content.tx_headless_news_teaser : metadata.ogdescription ? metadata.ogdescription : ''
}
export function getOGImage(metadata, content) {
  const image = content.tx_headless_news_image
  const meta_image = metadata.ogimage
  if (!image?.src && !meta_image?.src) {
    return getFallbackImage()
  }

  return {
    uid: image?.uid ? image.uid : meta_image?.uid ? meta_image.uid : null,
    src: image?.src ? image.src : meta_image?.src ? meta_image.src : null,
    title: image?.title ? image.title : meta_image?.title ? meta_image.title : null,
    alternative: image?.alternative ? image.alternative : meta_image?.alternative ? meta_image.alternative : null,
    copyright: image?.copyright ? image.copyright : meta_image?.copyright ? meta_image.copyright : null,
  }
}

export function getFallbackImage() {
  return {
    uid: null,
    src: `${process.env.PUBLIC_CDN_HOST}/images/brands/news-fallback-images/dfb.svg`,
    title: null,
    alternative: null,
    copyright: null,
  }
}
